 export const makeResetPasswordDTO = (domainName) => ({
  domainName,
  removeSessions: true,
});
